// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";
// import styles bundle
import "swiper/css/bundle";

(() => {
  const Moonbase = window.Moonbase || {};
  const SwiperConstructor = typeof Swiper === "function"
    ? Swiper
    : (Swiper && typeof Swiper.default === "function" ? Swiper.default : null);
  const swipers = document.querySelectorAll(".swiper");
  const defaultSettings = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
  };
  Moonbase.Swiper = SwiperConstructor || Swiper;
  window.Moonbase = Moonbase;

  swipers.forEach((swiper) => {
    let settings = swiper.dataset.swiper
      ? JSON.parse(swiper.dataset.swiper)
      : defaultSettings;
    return new Moonbase.Swiper(swiper, settings);
  });

  Moonbase.initSwiper = (swiper) => {
    let settings = JSON.parse(swiper.dataset.swiper || "{}");
    new Moonbase.Swiper(swiper, {
      ...defaultSettings,
      ...settings
    });
  };

  const mobileSwiper = document.querySelectorAll(".swiper-mobile");
  const mobileSwiperSettings = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
  };

  function initMobileSwiper() {
    if (window.innerWidth < 1024) {
      mobileSwiper.forEach((mobileSwiper) => {
        let settings = mobileSwiper.dataset.swiper
          ? JSON.parse(mobileSwiper.dataset.swiper)
          : mobileSwiperSettings;

        return new Moonbase.Swiper(mobileSwiper, settings);
      });
    } else {
      mobileSwiper.forEach((mobileSwiper) => {
        if (mobileSwiper.swiper) {
          const slides = mobileSwiper.swiper.slides;
          mobileSwiper.swiper.destroy(true,true);

          // Remove inline styles added by swiper
          slides.forEach((slide) => {
            slide.removeAttribute("style");
          });
        }
      });
    }
  }

  Moonbase.initSwiper = (swiper) => {
    let settings = JSON.parse(swiper.dataset.swiper || "{}");
    return new Moonbase.Swiper(swiper, {
      ...defaultSettings,
      ...settings,
    });
  };

  const originalInitSwiper = Moonbase.initSwiper;
  Moonbase.initSwiper = (swiper) => {
    const instance = originalInitSwiper(swiper);

    if (typeof Moonbase.initAccessibleLoopingSwipers === "function") {
      Moonbase.initAccessibleLoopingSwipers();
    }

    return instance;
  };

  window.addEventListener("resize", initMobileSwiper);
  window.addEventListener("DOMContentLoaded", initMobileSwiper);

})();

// Prevent keyboard users from getting trapped in looped swiper carousels.
(function initAccessibleLoopingSwipersFeature() {
  const Moonbase = window.Moonbase || {};
  const accessibleLoopingSwiperStates = new WeakMap();
  const registeredSwipers = new WeakSet();
  const GLOBAL_FOCUSABLE_SELECTOR = [
    "a[href]",
    "button:not([disabled])",
    'input:not([disabled]):not([type="hidden"])',
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])'
  ].join(",");
  const SLIDE_FOCUSABLE_SELECTOR =
    '.swiper-wrapper .swiper-slide a, .swiper-wrapper .swiper-slide button, .swiper-wrapper .swiper-slide [tabindex]:not([tabindex="-1"])';
  let tabNavigationDetected = false;

  function getSwiperConstructor() {
    const moonbaseSwiperCtor = window.Moonbase && window.Moonbase.Swiper;
    return typeof moonbaseSwiperCtor === "function" ? moonbaseSwiperCtor : Swiper;
  }

  function parseSwiperSettings(swiperEl) {
    if (!swiperEl.dataset.swiper) {
      return null;
    }

    try {
      return JSON.parse(swiperEl.dataset.swiper);
    } catch (error) {
      return null;
    }
  }

  function getActiveIndex(swiperInstance) {
    return typeof swiperInstance.realIndex === "number"
      ? swiperInstance.realIndex
      : swiperInstance.activeIndex;
  }

  function reinitializeSwiper(swiperEl, settings) {
    const swiperInstance = swiperEl.swiper;
    const SwiperCtor = getSwiperConstructor();

    if (!swiperInstance || !swiperInstance.params) {
      return null;
    }

    swiperEl.dataset.swiper = JSON.stringify(settings);
    swiperInstance.destroy(true, true);
    return new SwiperCtor(swiperEl, settings);
  }

  function resolveNavigationControls(swiperEl, state) {
    const controlContainer = swiperEl.parentElement || swiperEl;
    const prevControl = controlContainer.querySelector('.swiper-button-prev, [class*="swiper-button-prev-"]');
    const nextControl = controlContainer.querySelector('.swiper-button-next, [class*="swiper-button-next-"]');

    if (state) {
      state.prevControl = prevControl || state.prevControl;
      state.nextControl = nextControl || state.nextControl;
    }

    return {
      prevControl: (state && state.prevControl) || prevControl,
      nextControl: (state && state.nextControl) || nextControl,
    };
  }

  function disableNavigationControls(swiperEl, state) {
    if (!state || state.controlsDisabledForKeyboard) {
      return;
    }

    const { prevControl, nextControl } = resolveNavigationControls(swiperEl, state);
    const controls = [prevControl, nextControl];
    let controlsWereDisabled = false;

    controls.forEach((control) => {
      if (!control) {
        return;
      }

      control.setAttribute("aria-disabled", "true");
      control.setAttribute("tabindex", "-1");
      control.setAttribute("inert", "inert");
      control.style.pointerEvents = "none";
      control.classList.add("is-disabled");
      controlsWereDisabled = true;
    });

    if (controlsWereDisabled) {
      swiperEl.classList.add("swiper-loop-keyboard-a11y");
    }

    state.controlsDisabledForKeyboard = controlsWereDisabled;
  }

  function enableNavigationControls(swiperEl, state) {
    if (!state || !state.controlsDisabledForKeyboard) {
      return;
    }

    const { prevControl, nextControl } = resolveNavigationControls(swiperEl, state);

    [prevControl, nextControl].forEach((control) => {
      if (!control) {
        return;
      }

      control.removeAttribute("aria-disabled");
      control.removeAttribute("tabindex");
      control.removeAttribute("inert");
      control.style.pointerEvents = "";
      control.classList.remove("is-disabled");
    });

    swiperEl.classList.remove("swiper-loop-keyboard-a11y");

    state.controlsDisabledForKeyboard = false;
  }

  function focusFirstSlideItem(swiperEl) {
    const firstSlideFocusable = swiperEl.querySelector(SLIDE_FOCUSABLE_SELECTOR);

    if (firstSlideFocusable) {
      firstSlideFocusable.focus();
      return true;
    }

    return false;
  }

  function focusNextAfterContainer(container) {
    const focusableElements = Array.from(document.querySelectorAll(GLOBAL_FOCUSABLE_SELECTOR))
      .filter((el) => {
        if (!el.offsetParent && el !== document.activeElement) {
          return false;
        }

        if (el.hasAttribute("inert") || el.closest("[inert]")) {
          return false;
        }

        return true;
      });

    const containerIndex = focusableElements.findIndex((el) => container.contains(el));

    if (containerIndex === -1) {
      return;
    }

    const nextFocusable = focusableElements.slice(containerIndex + 1)
      .find((el) => !container.contains(el));

    if (nextFocusable) {
      nextFocusable.focus();
    }
  }

  function setLoopMode(swiperEl, state, loopEnabled) {
    if (!state || state.loopDisabledForKeyboard === !loopEnabled) {
      return;
    }

    const swiperInstance = swiperEl.swiper;
    if (!swiperInstance || !swiperInstance.params || (!loopEnabled && !swiperInstance.params.loop)) {
      return;
    }

    const activeIndex = getActiveIndex(swiperInstance);
    const settings = loopEnabled
      ? {
          ...state.originalSettings,
          loop: true
        }
      : {
          ...(parseSwiperSettings(swiperEl) || state.originalSettings),
          loop: false
        };

    const nextSwiper = reinitializeSwiper(swiperEl, settings);
    if (!nextSwiper) {
      return;
    }

    if (typeof activeIndex === "number") {
      if (loopEnabled && typeof nextSwiper.slideToLoop === "function") {
        nextSwiper.slideToLoop(activeIndex, 0, false);
      } else if (typeof nextSwiper.slideTo === "function") {
        nextSwiper.slideTo(activeIndex, 0, false);
      }
    }

    if (loopEnabled) {
      enableNavigationControls(swiperEl, state);
      state.loopDisabledForKeyboard = false;
      state.initialTabFocusHandled = false;
    } else {
      disableNavigationControls(swiperEl, state);
      state.loopDisabledForKeyboard = true;
    }
  }

  function restoreMouseInteraction(swiperEl) {
    tabNavigationDetected = false;
    swiperEl.classList.remove("swiper-loop-keyboard-a11y");
    setLoopMode(swiperEl, accessibleLoopingSwiperStates.get(swiperEl), true);
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
      tabNavigationDetected = true;
    }

    if (event.key === "Escape") {
      const activeElement = document.activeElement;
      if (!activeElement) {
        return;
      }

      const activeSwiper = activeElement.closest(".swiper[data-swiper]");
      if (activeSwiper && accessibleLoopingSwiperStates.has(activeSwiper)) {
        event.preventDefault();
        focusNextAfterContainer(activeSwiper);
      }
    }
  }, true);

  function registerLoopingSwiper(swiperEl) {
    const settings = parseSwiperSettings(swiperEl);

    if (!settings || settings.loop !== true) {
      return;
    }

    if (!accessibleLoopingSwiperStates.has(swiperEl)) {
      const { prevControl, nextControl } = resolveNavigationControls(swiperEl);

      accessibleLoopingSwiperStates.set(swiperEl, {
        prevControl,
        nextControl,
        originalSettings: settings,
        loopDisabledForKeyboard: false,
        controlsDisabledForKeyboard: false,
        initialTabFocusHandled: false
      });
    } else {
      const state = accessibleLoopingSwiperStates.get(swiperEl);
      state.originalSettings = settings;
    }

    if (registeredSwipers.has(swiperEl)) {
      return;
    }

    registeredSwipers.add(swiperEl);

    swiperEl.addEventListener("focusin", (event) => {
      if (!tabNavigationDetected) {
        return;
      }

      const state = accessibleLoopingSwiperStates.get(swiperEl);
      setLoopMode(swiperEl, state, false);

      if (!state || state.initialTabFocusHandled) {
        return;
      }

      const focusOnNavigationControl =
        (state.prevControl && state.prevControl.contains(event.target)) ||
        (state.nextControl && state.nextControl.contains(event.target));

      if (focusOnNavigationControl) {
        focusFirstSlideItem(swiperEl);
      }

      state.initialTabFocusHandled = true;
    });

    swiperEl.addEventListener("pointerdown", (event) => {
      if (event.pointerType !== "mouse") {
        return;
      }

      restoreMouseInteraction(swiperEl);
    });

    swiperEl.addEventListener("mousedown", () => restoreMouseInteraction(swiperEl));
    swiperEl.addEventListener("mouseenter", () => restoreMouseInteraction(swiperEl));
  }

  function initAccessibleLoopingSwipers() {
    document.querySelectorAll('.swiper[data-swiper]').forEach(registerLoopingSwiper);
  }

  Moonbase.initAccessibleLoopingSwipers = initAccessibleLoopingSwipers;
  window.Moonbase = Moonbase;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAccessibleLoopingSwipers);
  } else {
    initAccessibleLoopingSwipers();
  }

  document.addEventListener("shopify:section:load", initAccessibleLoopingSwipers);
}());